import { render, staticRenderFns } from "./solutionDetails3.vue?vue&type=template&id=086d0996&scoped=true&"
import script from "./solutionDetails3.vue?vue&type=script&lang=js&"
export * from "./solutionDetails3.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails3.vue?vue&type=style&index=0&id=086d0996&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086d0996",
  null
  
)

export default component.exports